import React, { useContext } from "react";
import {
  getCommentCreatorDetails,
  getCommentCreatorName,
} from "common-client/utils/comments";
import { GetCommentsForObjectQuery } from "../../generated/graphql";
import { spacing } from "../../stitches.config";
import { AuthContext } from "../Authorization/AuthContext";
import { FlexRow } from "../Common/__styles__/Layout";
import { Markdown } from "../Common/__styles__/Markdown";
import { Body } from "../Common/Typography";

type CommentType = NonNullable<
  GetCommentsForObjectQuery["getCommentsForObject"]
>[number];

export const Comment = ({ comment }: { comment: CommentType }) => {
  const { user, admin, publicUser } = useContext(AuthContext);
  const currentUser = user || admin || publicUser;

  const creator = getCommentCreatorName({
    createdBy: comment.createdBy,
    currentUserId: currentUser?.id,
  });

  const details = getCommentCreatorDetails({
    createdBy: comment.createdBy,
    createdAt: comment.createdAt,
  });

  return (
    <div style={{ padding: `${spacing.m}` }}>
      <FlexRow style={{ gap: `${spacing.s}` }}>
        <Body size="small" type="emphasis">
          {creator}
        </Body>
        <Body size="small" type="regular" color="contentSecondary">
          {details}
        </Body>
      </FlexRow>
      <Body size="default" type="regular" as="div">
        <Markdown
          markdown={comment.content}
          options={{ simpleLineBreaks: true }}
        />
      </Body>
    </div>
  );
};
